// extracted by mini-css-extract-plugin
module.exports = {"MainInputWrapper":"MainInput_MainInputWrapper__35hbJ","MainInputText":"MainInput_MainInputText__aiXLF","MainInput":"MainInput_MainInput__2wZvw"};